import React, { useState } from "react";
import styled from "styled-components";
import { toast } from "react-toastify";
import axios from "axios";
import { FieldGroup, InputPassword } from "../components/Input";
import Button from "../components/Button";
import { useParams } from "react-router-dom";
import { API_ENDPOINTS } from "../config/api";
import useTranslation from "../hooks/useTranslation";

// Import Icons

const NewPasswOrd = ({ match }) => {
  const { t } = useTranslation();
  const { token } = useParams();
  const [data, setData] = useState({
    newPassword: "",
    confirmNewPassword: "",
  });
  const [errors, setErrors] = useState({
    newPassword: "",
    confirmNewPassword: "",
  });

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  function checkComfirmPassword(password, confirmPassword) {
    if (password !== confirmPassword) return "Confirm password is deffirent";
    if (confirmPassword.length === 0) return "Empty Field";
    return "";
  }
  function checkPassword(password) {
    if (password?.length === 0) return "Empty Field";
    if (password?.length < 8) return "You better enter 8 characters longer";
    return "";
  }

  function formValid() {
    setErrors({
      newPassword: checkPassword(data.newPassword),
      confirmNewPassword: checkComfirmPassword(data.newPassword, data.confirmNewPassword),
    });
    if (
      data.newPassword.length >= 8 &&
      data.confirmNewPassword.length > 0 &&
      data.confirmNewPassword === data.newPassword
    )
      return true;
    return false;
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formValid()) return;
    axios
      .post(
        API_ENDPOINTS.NEW_PASSWORD + token,
        { password: data.newPassword },
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        toast.success(res.data.message);
      })
      .catch((err) => {
        if (err.response.status === 400) toast.warn(err.response.data.message);
      });
    setErrors({});
  };
  return (
    <NewPasswprdStyle>
      <button className="close-btn" onClick={() => { window.location.href = "/"; }} aria-label="Close">×</button>
      <header>
        <h2>{t('newpassword.choose_new_password')}</h2>
      </header>
      <form onSubmit={handleSubmit} noValidate>
        <FieldGroup label={t('newpassword.new_password')}>
          <InputPassword
            name="newPassword"
            placeholder={t('newpassword.enter_new_password')}
            alert={errors.newPassword}
            onChange={handleChange}
          />
        </FieldGroup>
        <FieldGroup label={t('newpassword.confirm_new_password')}>
          <InputPassword
            name="confirmNewPassword"
            placeholder={t('newpassword.confirm_new_password')}
            alert={errors.confirmNewPassword}
            onChange={handleChange}
          />
        </FieldGroup>
        <Button type="submit" variant="primary">
          {t('newpassword.confirm_button')}
        </Button>
      </form>
    </NewPasswprdStyle>
  );
};
export default NewPasswOrd;

const NewPasswprdStyle = styled.div`
  max-width: 400px;
  margin: 10vw auto 0;
  position: relative;
  .close-btn {
    position: absolute;
    top: -24px;
    right: -24px;
    background: transparent;
    border: none;
    color: ${({ theme }) => theme.color.primaryText};
    font-size: 28px;
    cursor: pointer;
  }
  header {
    margin-bottom: 3rem;
    h2 {
      margin-bottom: 10px;
    }
    p {
      color: ${({ theme }) => theme.color.lighterText};
    }
  }
  form {
    button {
      width: 100%;
      margin-top: 20px;
    }
  }
`;
